import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { firstValueFrom, Observable } from 'rxjs';
import { getProyect } from './query';

export class Proyectos {
  public id?: Number;
  public name?: String;
  public weighing?: Number;
  public description?: String;

  public objectiveIds?: Number[];
  public responsibleId?: Number;
  public strategyIds?: Number[];
}

export class historicoPeso{
  period?: string;
  weighing?: number;
  projectId?: number;
}
@Injectable({
  providedIn: 'root'
})
export class ProyectosService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private readonly cookies: CookieService,
    private readonly http: HttpClient,
    private readonly apollo: Apollo,
  ) { }

  async getProyectsGQL(id: string[]){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
        query: getProyect,
        context: {headers: this.headers},
        variables: {
          "args": {
            "filter": {
              "conditions": [
                {
                  "field": "id",
                  "operator": "IN",
                  "value": id
                }
              ]
            }
          }
        },
        fetchPolicy: 'no-cache'
      }).valueChanges
    );
    return data.searchProjects.data;
  }

  public postProyectos(proy: any): Observable<any> {
    var proyect: Proyectos;
    if (proy.descripcion !== '') {
      proyect = {
        strategyIds: proy.programaId,
        objectiveIds: proy.objetiveId,
        name: proy.nombre,
        description: proy.description,
        weighing: Number(proy.ponderacion),
        responsibleId: Number(proy.responsibleId)
      }
    } else {
      proyect = {
        strategyIds: proy.programaId,
        objectiveIds: proy.objetiveId,
        name: proy.nombre,
        weighing: Number(proy.ponderacion),
        responsibleId: Number(proy.responsibleId)
      }
    }
    const body = JSON.stringify(proyect);
    const apiURL = this.apiURL + "proyectos";
    return this.http.post(`${apiURL}`, body, { headers: this.headers });
  }

  public patchProyectos(proy: any): Observable<any> {
    const proyect: Proyectos = {
      objectiveIds: proy.objetiveId,
      name: proy.name,
      description: proy.description,
      weighing: Number(proy.weighing),
      responsibleId: Number(proy.responsibleId)
    }
    const body = JSON.stringify(proyect);
    const apiURL = this.apiURL + "proyectos/" + proy.id;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }

  public deleteProyectos(proy: any): Observable<any> {
    const apiURL = this.apiURL + "proyectos/" + proy.id;
    return this.http.delete(`${apiURL}`, { headers: this.headers });
  }

  public postHistoricoPeso(peso: any, idPro: any, anio: string): Observable<any>{
      const pon: historicoPeso = {
        weighing: peso,
        period: `${anio}-01`,
        projectId: Number(idPro),
      }
      const body = JSON.stringify(pon);
      const apiURL = this.apiURL+"proyectos/"+idPro+"/ponderacion-historial";
      return this.http.post(`${apiURL}`, body, {headers: this.headers});
    }

  public patchHistoricoPeso(hist: any, idPro: any, idPes: string): Observable<any>{
      const pon: historicoPeso = {
        weighing: hist.peso,
        period: `${hist.anio}-01`
      }
      const body = JSON.stringify(pon);
      const apiURL = this.apiURL+"proyectos/"+idPro+"/ponderacion-historial/"+idPes;
      return this.http.patch(`${apiURL}`, body, {headers: this.headers});
    }

  public deleteHistoricoPeso(idPro: any, idPes: string): Observable<any>{    
    const apiURL = this.apiURL+"proyectos/"+idPro+"/ponderacion-historial/"+idPes;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }
}
